<template>
<!--  联系专家  -->
  <div class="contact-box">
    <div class="contact-box-backLeft"></div>
    <div class="contact-box-backRight"></div>

    <div class="contact-con clearfix">
      <div class="contact-left">
        <div>立即与技术专家聊聊</div>
        <img src="../../assets/img/homePage/contact-code.png" style="width: 190px;height: 190px;">
        <ul>
          <li><img src="../../assets/img/homePage/contact-check.png">在线交流</li>
          <li><img src="../../assets/img/homePage/contact-check.png">POC验证</li>
        </ul>
      </div>
      <div class="contact-right">
        <div class="contact-img"></div>
        <div>我们将在3个小时内致电沟通</div>
        <!-- 表单 -->
        <el-form label-position="top" :model="formData" :rules="formRules" ref="form">
          <el-form-item prop="companyname">
            <el-autocomplete
              v-model="formData.companyname"
              placeholder="您的单位名称"
              :fetch-suggestions="querySearch"
              :trigger-on-focus="false"
              value-key="name"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item prop="usename">
            <el-input v-model="formData.usename" placeholder="您的姓名" required></el-input>
          </el-form-item>
          <el-form-item prop="phone">
            <el-input v-model="formData.phone" placeholder="您的联系方式" required></el-input>
          </el-form-item>
          <!-- 验证码功能已暂时隐藏 -->
          <el-form-item class="form-checkCode" prop="checkCode">
            <el-input v-model="formData.checkCode" placeholder="请输入验证码" required></el-input>
            <span class="code" @click="sendCode" :class="{'isDisabled': isSend}">{{sendmsg}}</span>
          </el-form-item>
        </el-form>
        <el-button class="form-btn" @click="submit">开始体验</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {sendCode, submitForm, queryCompanyName} from "../../api/form";

export default {
  name: "ContactExperts",
  data(){
    return{
      formData: {
        companyname: '',
        usename: '',
        phone: '',
        job: '项目经理',
        checkCode: '', // 验证码
        // sourceway: '', // 访问途径
        registerProduct: '轻骑兵', // 注册信息的产品
        interestProduct: '轻骑兵', // 感兴趣产品
        concreteDemand: '轻骑兵低代码开发平台', // 具体需求
        productId:"624532455348772864",
        campaignName:'',
        formResource:'官网底部表单'
      },
      formRules: {
        companyname: [{ required: true, message: ' ', trigger: 'blur' },],
        usename: [{ required: true, message: ' ', trigger: 'blur' },],
        phone: [{ required: true, message: ' ', trigger: 'blur' },],
        checkCode: [{ required: true, message: ' ', trigger: 'blur' },],
      },
      isSend: false,
      sendmsg:'获取验证码',
      isSubmit:false,
    }
  },
  methods:{
    // 查询单位名称
    async querySearch(queryString, cb) {
      const self = this;
      let resList = [];
      await queryCompanyName({word: queryString}).then((res) => {
        if ((res.status === '200' || res.status === 200)) {
          if(res.data.result !=null){
            resList = res.data.result.items || [];
            cb(resList);
          }
        } else {
          self.$message.error(res.data);
        }
      }).catch((error) => {
      });
      console.log(resList);

    },
    // 校验手机号
    checkPhone() {
      const self = this;
      const reg = /^1[3-9]\d{9}$/;
      if (!reg.test(self.formData.phone)) {
        self.$message.error('请输入正确的联系方式!');
        return false;
      }
      return true;
    },
    // 发送验证码
    sendCode() {
      const self = this;
      if(this.isSend){
        return;
      }
      self.isSend = true;
      if (!self.checkPhone()) {
        self.isSend = false;
        return;
      }
      sendCode(self.formData.phone).then((res) => {
        let msg = '';
        if (typeof res.data === 'string') {
          if (res.data.indexOf('msg') > -1 && res.data.indexOf('发送成功') > -1) {
            msg = '发送成功';
          } else {
            msg = res.data;
          }
        } else {
          msg = res.data.msg;
        }
        if ((res.status === '200' || res.status === 200) && msg === '发送成功') {
          self.$message.success('验证码发送成功!');
          let timer = 60;
          this.sendmsg = timer + " s";
          this.timeFun = setInterval(() => {
            --timer;
            this.sendmsg = timer + " s";
            if (timer == 0) {
              self.isSend = false;
              this.sendmsg = "重新发送";
              clearInterval(this.timeFun);
            }
          }, 1000);
        } else {
          self.$message.error(msg);
        }
      }).catch((error) => {
        self.$message.error('验证码发送失败!');
        self.isSend = false;
      });
    },
    // 提交表单
    submit() {
      // 判断用户如何进入网站
      var campaignName;
      var beforeUrl = document.referrer;
      var nowUrl = window.location.href;
      // 广告推广进入
      if (nowUrl.indexOf('pk_campaign') !== -1) {
        let searchParams = new URLSearchParams(nowUrl.split('?')[1]); // 获取查询参数
        let pkSource = searchParams.get('pk_campaign'); // 获取 pk_campaign 的值
        if (pkSource) {
          campaignName = pkSource;
        }
      }
      if (!beforeUrl && !campaignName) {
        // 直接地址栏进入
        campaignName = 'directaccess';
      } else if (!campaignName){
        // 自然搜索进入
        var start = beforeUrl.indexOf('.') + 1;
        var end = beforeUrl.indexOf('.', start);
        if (start && end) {
          var result = beforeUrl.substring(start, end);
          if (result === 'baidu') {
            campaignName = 'organic-search-baidu';
          } else if (result === 'so') {
            campaignName = 'organic-search-360';
          } else if (result === 'google') {
            campaignName = 'organic-search-google';
          } else if (result === 'sogou') {
            campaignName = 'organic-search-sogou';
          } else if (result === 'bing') {
            campaignName = 'organic-search-bing';
          } else {
            campaignName = 'organic-search-other';
          }
        }
      }
      const self = this;
      if (campaignName) self.formData.campaignName = campaignName;
      let error = false;
      self.$refs.form.validate((valid) => {
        if (valid) {
          error = false;
        } else {
          error = true;
        }
      });
      if (error) {
        return;
      }
      const param = self.formData;
      submitForm(param).then((res) => {
        if ((res.status === '200' || res.status === 200) && (res.data === "注册成功"|| res.data === '')) {
          self.$message.success('提交成功!');
           self.$refs.form.resetFields()
          self.isSubmit = true;
          this.isSend = false;
          this.sendmsg = '获取验证码';
        } else {
          self.$message.error(res.data);
        }
      }).catch((error) => {
        self.$message.error('提交失败!');
      });
    },
  }
}
</script>

<style scoped>
/* 联系专家 */
.contact-box {
  height: 400px;
  background: url('../../assets/img/homePage/contact-bg.webp') no-repeat 50% !important;
  position: relative;
}
.contact-box-backLeft{width: calc(50% - 960px);left:0;bottom:0;height:400px;background-color: #dfedff;position: absolute;}
.contact-box-backRight{width: calc(50% - 960px);right: 0;bottom:0;height:400px;background-color: #125FE0;position: absolute;}
.contact-con {width: 1200px;margin: 0 auto;position: relative;font-size: 16px;z-index: 2;}
.contact-left {position: relative;float: left;width: 320px;margin-top: 112px;}
.contact-left > div {margin-bottom: 22px;}
.contact-left ul {display: inline-block;margin-left: 20px;color: #186CF5;line-height: 32px;position: relative;top: -3px;}
.contact-left ul img {margin-right: 5px;}
.contact-right {float: right;width: 344px;color: #FFF;margin-top: 46px;}
.contact-right .contact-img {background: url('../../assets/img/homePage/hussar.webp');width: 394px;height: 410px;transform: scale(0.8);position: absolute;left: 33%;top: 0;}
.contact-right > div {margin-bottom: 20px;}
.contact-right >>> .el-form-item {margin-bottom: 12px;}
.contact-right >>> .el-form-item__content {line-height: 44px;}
.contact-right >>> .el-input__inner {height: 44px;line-height: 44px;background: rgba(255,225,255, 0.28);border: 1px solid transparent;color: #FFF;}
.contact-right >>> .el-form-item.is-error .el-input__inner {border-color: #F56C6C;}
.contact-right >>> .el-input__inner::placeholder {color: #FFF;}
.contact-right >>> .el-autocomplete {width: 100%;}
.form-checkCode >>> .el-input {width: 233px;display: inline-block;}
.form-checkCode .code {
  display: inline-block;
  width: 105px;height: 44px;background: #FFF;border-radius: 4px;
  line-height: 44px;text-align: center;color: #186CF5;}
.form-btn {width: 100%;height: 44px;padding: 0;background: #36BCF3;border: none;color: #FFF;line-height: 44px;font-size: 16px;}
.form-btn:hover{background: rgba(54, 188, 243, 0.9)}
</style>



// WEBPACK FOOTER //
// src/components/include/ContactExperts.vue